import {
  B000190SokoNmSokoshubetsuKbn,
  B000200Get,
  B000200GetByJanCd,
  catchRestError,
  RestClient,
} from "..";
import { UseFormReturn } from "react-hook-form";
import {
  getJuchutanka,
  getJuchuKin,
  getJodaitanka,
  getHitsuyosu,
  getKakeritsu,
  getUchizeiJuchutanka,
} from "services/CalcService";
import {
  juchuSeisanhinKbn,
  setshohinKbn,
  shohinshubetsuKbn,
  tankaKbn,
  tenyuryokujodaiKbn,
  tenyuryokujuchuKbn,
} from "services/codes";
import { Big } from "big.js";
import {
  getSCode,
  HyoziKazeiKbn,
  JuchuSeisanhinKbn,
  ZeiKbn,
} from "messages/codes";
import { date } from "services";

const tankaKbnNormal = "0";
const whtankaKbnWh = "0";

export type B010010CreateRequest = {
  juchuKbn: string;
  juchuYmd: string;
  tokuiCd: string;
  tokuishitenCd: string;
  tokuiNm: string;
  nonyuCd: string;
  nonyushitenCd: string;
  nonyuNm: string;
  shainCd: string;
  shukayoteiYmd: string;
  denpyoYmd: string;
  chohaKbn: string;
  hasosakiCd: string;
  hasokbnCd: string;
  // 明細
  b010010MeiRequest: B010010CreateMeiRequest[];
} & Partial<{
  juchudenpyoNo: string;
  nohinyoteiYmd: string;
  tokuiPostCd: string;
  tokuiAddress1: string;
  tokuiAddress2: string;
  tokuiTelNo: string;
  tokuiFaxNo: string;
  nonyuPostCd: string;
  nonyuAddress1: string;
  nonyuAddress2: string;
  nonyuTelNo: string;
  nonyuFaxNo: string;
  edimemo: string;
  seisakuYmd: string;
  jisanYmd: string;
  assistantCd: string;
  denpyoshubetsuCd: string;
  tenpudenpyoCd: string;
  bunrui: string;
  unsogaishaCd: string;
  bumonCd: string;
  ppgakeKbn: string;
  netsukeKbn: string;
  chumonNo: string;
  denpyoKbn: string;
  ritsu: string;
  hinbetsuNo: string;
  tantosha: string;
  bikoCd: string;
  biko: string;
  nohinsaki: string;
  lineCd: string;
  uribaNm: string;
  naisen: string;
  version: string;
}>;

export type B010010CreateMeiRequest = {
  juchugyoNo: string;
  uchiwakeKbn: string;
  yoyakuKbn: string;
  shohinCd: string;
  janCd: string;
  sokoCd: string;
  juchusu: string;
  juchutanka: string;
  kakeritsu: string;
} & Partial<{
  aiteCd: string;
  shohinNm: string;
  sotosunW: string;
  uchisunW: string;
  sotosunH: string;
  uchisunH: string;
  tenyuryokujodaiKbn: string;
  tenyuryokujuchuKbn: string;
  jodaitanka: string;
  juchuKin: string;
  meisaibikoCd: string;
  meisaibiko: string;
  kazeiKbn: string;
  setshohinKbn: string;
  edishohinNm: string;
  shohinshubetsuKbn: string;
  tankaKbn: string;
  // 明細
  b010010MeiKoseiRequest: B010010CreateMeiKoseiRequest[];
}>;

export type B010010CreateMeiKoseiRequest = {
  juchugyoNo: string;
  juchukoseigyoNo: string;
  shohinCd: string;
  janCd: string;
  sokoCd: string;
  koseisu: string;
  juchutanka: string;
  kakeritsu: string;
  juchuKin: string;
} & Partial<{
  aiteCd: string;
  shohinNm: string;
  sotosunW: string;
  uchisunW: string;
  sotosunH: string;
  uchisunH: string;
  hitsuyosu: string;
  tenyuryokujodaiKbn: string;
  tenyuryokujuchuKbn: string;
  jodaitanka: string;
  meisaikoseiBikoCd: string;
  meisaikoseiBiko: string;
  kazeiKbn: string;
  shohinshubetsuKbn: string;
  tankaKbn: string;
}>;

export type B010010CreateRsponse = {
  juchudenpyoNo: string;
};

//受注入力登録処理メソッド
export const B010010Create = (methods: UseFormReturn, rows: any) => {
  const fields = methods.getValues();

  // マッピング
  // 明細
  const meiData: B010010CreateMeiRequest[] = rows.map((row: any) => {
    // セット構成品の名称を変更
    row.b010010MeiKoseiRequest = row.koseiData;
    return row;
  });

  // ヘッダー
  const data: B010010CreateRequest = {
    juchuKbn: fields.juchuKbn.value,
    juchudenpyoNo: fields.juchudenpyoNo,
    juchuYmd: fields.juchuYmd,
    nohinyoteiYmd: fields.nohinyoteiYmd,
    tokuiCd: fields.tokuiCd,
    tokuishitenCd: fields.tokuishitenCd,
    tokuiNm: fields.tokuiNm,
    tokuiPostCd: fields.tokuiPostCd,
    tokuiAddress1: fields.tokuiAddress1,
    tokuiAddress2: fields.tokuiAddress2,
    tokuiTelNo: fields.tokuiTelNo,
    tokuiFaxNo: fields.tokuiFaxNo,
    nonyuCd: fields.nonyuCd,
    nonyushitenCd: fields.nonyushitenCd,
    nonyuNm: fields.nonyuNm,
    nonyuPostCd: fields.nonyuPostCd,
    nonyuAddress1: fields.nonyuAddress1,
    nonyuAddress2: fields.nonyuAddress2,
    nonyuTelNo: fields.nonyuTelNo,
    nonyuFaxNo: fields.nonyuFaxNo,
    edimemo: fields.edimemo,
    shainCd: fields.shainCd,
    seisakuYmd: fields.seisakuYmd,
    shukayoteiYmd: fields.shukayoteiYmd,
    jisanYmd: fields.jisanYmd,
    denpyoYmd: fields.denpyoYmd,
    chohaKbn: fields.chohaKbn.value,
    hasosakiCd: fields.hasosakiCd.value,
    hasokbnCd: fields.hasokbnCd.value,
    assistantCd: fields.assistantCd,
    denpyoshubetsuCd: fields.denpyoshubetsuCd,
    tenpudenpyoCd: fields.tenpudenpyoCd,
    bunrui: fields.bunrui,
    unsogaishaCd: fields.unsogaishaCd,
    bumonCd: fields.bumonCd,
    ppgakeKbn: fields.ppgakeKbn.value,
    netsukeKbn: fields.netsukeKbn.value,
    chumonNo: fields.chumonNo,
    denpyoKbn: fields.denpyoKbn,
    ritsu: fields.ritsu,
    hinbetsuNo: fields.hinbetsuNo,
    tantosha: fields.tantosha,
    bikoCd: fields.bikoCd,
    biko: fields.biko,
    nohinsaki: fields.nohinsaki,
    lineCd: fields.lineCd,
    uribaNm: fields.uribaNm,
    naisen: fields.naisen,
    version: fields.version,
    b010010MeiRequest: [...meiData],
  };

  return RestClient.post<B010010CreateRsponse>("b010010/create", data);
};

export type B010010UpdateRequest = {
  juchuKbn: string;
  juchudenpyoNo: string;
  juchuYmd: string;
  tokuiCd: string;
  tokuishitenCd: string;
  tokuiNm: string;
  nonyuCd: string;
  nonyushitenCd: string;
  nonyuNm: string;
  shainCd: string;
  shukayoteiYmd: string;
  denpyoYmd: string;
  chohaKbn: string;
  hasosakiCd: string;
  hasokbnCd: string;
  // 明細
  b010010MeiRequest: B010010UpdateMeiRequest[];
} & Partial<{
  nohinyoteiYmd: string;
  tokuiPostCd: string;
  tokuiAddress1: string;
  tokuiAddress2: string;
  tokuiTelNo: string;
  tokuiFaxNo: string;
  nonyuPostCd: string;
  nonyuAddress1: string;
  nonyuAddress2: string;
  nonyuTelNo: string;
  nonyuFaxNo: string;
  edimemo: string;
  seisakuYmd: string;
  jisanYmd: string;
  assistantCd: string;
  denpyoshubetsuCd: string;
  tenpudenpyoCd: string;
  bunrui: string;
  unsogaishaCd: string;
  bumonCd: string;
  ppgakeKbn: string;
  netsukeKbn: string;
  chumonNo: string;
  denpyoKbn: string;
  ritsu: string;
  hinbetsuNo: string;
  tantosha: string;
  bikoCd: string;
  biko: string;
  nohinsaki: string;
  lineCd: string;
  uribaNm: string;
  naisen: string;
  version: string;
}>;

export type B010010UpdateMeiRequest = {
  juchugyoNo: string;
  uchiwakeKbn: string;
  yoyakuKbn: string;
  shohinCd: string;
  janCd: string;
  sokoCd: string;
  juchusu: string;
  juchutanka: string;
  kakeritsu: string;
  juchuKin: string;
} & Partial<{
  aiteCd: string;
  shohinNm: string;
  sotosunW: string;
  uchisunW: string;
  sotosunH: string;
  uchisunH: string;
  tenyuryokujodaiKbn: string;
  tenyuryokujuchuKbn: string;
  jodaitanka: string;
  meisaibikoCd: string;
  meisaibiko: string;
  kazeiKbn: string;
  setshohinKbn: string;
  crtDate: string;
  crtshainCd: string;
  edishohinNm: string;
  shohinshubetsuKbn: string;
  tankaKbn: string;
  // 明細
  b010010MeiKoseiRequest: B010010UpdateMeiKoseiRequest[];
}>;

export type B010010UpdateMeiKoseiRequest = {
  juchugyoNo: string;
  juchukoseigyoNo: string;
  shohinCd: string;
  janCd: string;
  sokoCd: string;
  koseisu: string;
  juchutanka: string;
  kakeritsu: string;
} & Partial<{
  aiteCd: string;
  shohinNm: string;
  sotosunW: string;
  uchisunW: string;
  sotosunH: string;
  uchisunH: string;
  hitsuyosu: string;
  tenyuryokujodaiKbn: string;
  tenyuryokujuchuKbn: string;
  jodaitanka: string;
  juchuKin: string;
  koseimeisaibikoCd: string;
  koseimeisaibiko: string;
  kazeiKbn: string;
  crtDate: string;
  crtshainCd: string;
  shohinshubetsuKbn: string;
  tankaKbn: string;
}>;

//受注入力更新処理メソッド
export const B010010Update = (methods: UseFormReturn, rows: any) => {
  const fields = methods.getValues();

  // マッピング
  // 明細
  const meiData: B010010UpdateMeiRequest[] = rows.map((row: any) => {
    // セット構成品の名称を変更
    row.b010010MeiKoseiRequest = [...row.koseiData];
    return row;
  });

  // ヘッダー
  const data: B010010UpdateRequest = {
    juchuKbn: fields.juchuKbn.value,
    juchudenpyoNo: fields.juchudenpyoNo,
    juchuYmd: fields.juchuYmd,
    nohinyoteiYmd: fields.nohinyoteiYmd,
    tokuiCd: fields.tokuiCd,
    tokuishitenCd: fields.tokuishitenCd,
    tokuiNm: fields.tokuiNm,
    tokuiPostCd: fields.tokuiPostCd,
    tokuiAddress1: fields.tokuiAddress1,
    tokuiAddress2: fields.tokuiAddress2,
    tokuiTelNo: fields.tokuiTelNo,
    tokuiFaxNo: fields.tokuiFaxNo,
    nonyuCd: fields.nonyuCd,
    nonyushitenCd: fields.nonyushitenCd,
    nonyuNm: fields.nonyuNm,
    nonyuPostCd: fields.nonyuPostCd,
    nonyuAddress1: fields.nonyuAddress1,
    nonyuAddress2: fields.nonyuAddress2,
    nonyuTelNo: fields.nonyuTelNo,
    nonyuFaxNo: fields.nonyuFaxNo,
    edimemo: fields.edimemo,
    shainCd: fields.shainCd,
    seisakuYmd: fields.seisakuYmd,
    shukayoteiYmd: fields.shukayoteiYmd,
    jisanYmd: fields.jisanYmd,
    denpyoYmd: fields.denpyoYmd,
    chohaKbn: fields.chohaKbn.value,
    hasosakiCd: fields.hasosakiCd.value,
    hasokbnCd: fields.hasokbnCd.value,
    assistantCd: fields.assistantCd,
    denpyoshubetsuCd: fields.denpyoshubetsuCd,
    tenpudenpyoCd: fields.tenpudenpyoCd,
    bunrui: fields.bunrui,
    unsogaishaCd: fields.unsogaishaCd,
    bumonCd: fields.bumonCd,
    ppgakeKbn: fields.ppgakeKbn.value,
    netsukeKbn: fields.netsukeKbn.value,
    chumonNo: fields.chumonNo,
    denpyoKbn: fields.denpyoKbn,
    ritsu: fields.ritsu,
    hinbetsuNo: fields.hinbetsuNo,
    tantosha: fields.tantosha,
    bikoCd: fields.bikoCd,
    biko: fields.biko,
    nohinsaki: fields.nohinsaki,
    lineCd: fields.lineCd,
    uribaNm: fields.uribaNm,
    naisen: fields.naisen,
    version: fields.version,
    b010010MeiRequest: [...meiData],
  };

  return RestClient.put("b010010/update", data);
};

// 商品変更メソッド(商品コード)
export const B010010HandleChangeShohinCd = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const meiFields = meiMethods.getValues();
  if (meiFields.shohinCd === "") {
    // 受注明細、紐づくセット構成品データの全項目をクリア
    HandleClearMeiByShohinCd(meiMethods);
    return;
  }
  // 商品名、janCd表示
  await B000200Get({ shohinCd: meiFields.shohinCd })
    .then((response) => {
      meiMethods.setValue("janCd", response.data.janCd ?? "");
      meiMethods.setValue("shohinNm", response.data.shohinNm ?? "");
    })
    .catch((reason) => {
      // 返却値が存在しない場合
      // 受注明細、紐づくセット構成品データの全項目をクリア
      HandleClearMeiByShohinCd(meiMethods);

      catchRestError(reason, navigate, setMsg);
    });
  // 商品関連項目設定処理
  await B010010Shohin(methods, meiMethods, navigate, setMsg);
};

// 商品変更メソッド(janコード)
export const B010010HandleChangeJanCd = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const meiFields = meiMethods.getValues();
  if (meiFields.janCd === "") {
    // 受注明細、紐づくセット構成品データの全項目をクリア
    HandleClearMeiByJanCd(meiMethods);
    return;
  }
  // 商品コード、商品名表示
  await B000200GetByJanCd({ janCd: meiFields.janCd })
    .then((response) => {
      meiMethods.setValue("shohinCd", response.data.shohinCd ?? "");
      meiMethods.setValue("shohinNm", response.data.shohinNm ?? "");
    })
    .catch((reason) => {
      // 返却値が存在しない場合
      // 受注明細、紐づくセット構成品データの全項目をクリア
      HandleClearMeiByJanCd(meiMethods);

      catchRestError(reason, navigate, setMsg);
    });
  // 商品関連項目設定処理
  await B010010Shohin(methods, meiMethods, navigate, setMsg);
};

// 明細クリア(商品コード変更時)
const HandleClearMeiByShohinCd = async (meiMethods: UseFormReturn) => {
  // 受注明細、紐づくセット構成品データの全項目をクリア
  const { shohinCd, meiTab, uchiwakeKbn } = meiMethods.getValues();
  // 明細、セット構成品をクリア(一部の値は保持しておく)
  meiMethods.reset();
  meiMethods.reset({
    ...meiMethods.getValues(),
    janCd: "",
  });
  meiMethods.setValue("shohinCd", shohinCd);
  meiMethods.setValue("meiTab", meiTab);
  meiMethods.setValue("uchiwakeKbn", uchiwakeKbn);
};

// 明細クリア(JANコード変更時)
const HandleClearMeiByJanCd = async (meiMethods: UseFormReturn) => {
  // 受注明細、紐づくセット構成品データの全項目をクリア
  const { janCd, meiTab, uchiwakeKbn } = meiMethods.getValues();
  // 明細、セット構成品をクリア(一部の値は保持しておく)
  meiMethods.reset();
  meiMethods.reset({
    ...meiMethods.getValues(),
    shohinCd: "",
  });
  meiMethods.setValue("janCd", janCd);
  meiMethods.setValue("meiTab", meiTab);
  meiMethods.setValue("uchiwakeKbn", uchiwakeKbn);
};

export type B010010GetShohinRequest = {
  shohinCd: string;
};

export type B010010GetShohinResponse = {
  vol: string;
  kazeiKbn: string;
  tankaKbn: string;
  setshohinKbn: string;
  shohinshubetsuKbn: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  shokuchiKbn: string;
  whtankaCd: string;
  zaikokanriKbn: string;
};

export const B010010GetShohin = (props: B010010GetShohinRequest) => {
  return RestClient.get<B010010GetShohinResponse>("b010010/get/shohin", {
    params: props,
  });
};

//商品マスタ詳細情報取得処理メソッド(商品コード、JANコード入力)
export const B010010Shohin = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();
  const meiFields = meiMethods.getValues();
  if (meiFields.shohinCd === "") {
    meiMethods.setValue("vol", "");
    meiMethods.setValue("kazeiKbnView", "");
    meiMethods.setValue("kazeiKbn", "");
    meiMethods.setValue("tankaKbn", "");
    meiMethods.setValue("setshohinKbn", "");
    meiMethods.setValue("shohinshubetsuKbn", "");
    meiMethods.setValue("sotosunW", "");
    meiMethods.setValue("sotosunH", "");
    meiMethods.setValue("uchisunW", "");
    meiMethods.setValue("uchisunH", "");
    meiMethods.setValue("shokuchiKbn", "");
    meiMethods.setValue("kakeritsu", "");
    meiMethods.setValue("whtankaCd", "");
    return;
  }
  await B010010GetShohin({ shohinCd: meiFields.shohinCd })
    .then((response) => {
      meiMethods.setValue("vol", response.data.vol ?? "");
      meiMethods.setValue(
        "kazeiKbnView",
        getSCode(HyoziKazeiKbn, response.data.kazeiKbn.toString() ?? "")?.label
      );
      meiMethods.setValue("kazeiKbn", response.data.kazeiKbn ?? "");
      meiMethods.setValue("tankaKbn", response.data.tankaKbn ?? "");
      meiMethods.setValue("setshohinKbn", response.data.setshohinKbn ?? "");
      meiMethods.setValue(
        "shohinshubetsuKbn",
        response.data.shohinshubetsuKbn ?? ""
      );
      meiMethods.setValue("sotosunW", response.data.sotosunW ?? "");
      meiMethods.setValue("sotosunH", response.data.sotosunH ?? "");
      meiMethods.setValue("uchisunW", response.data.uchisunW ?? "");
      meiMethods.setValue("uchisunH", response.data.uchisunH ?? "");
      meiMethods.setValue("shokuchiKbn", response.data.shokuchiKbn ?? "");
      meiMethods.setValue("whtankaCd", response.data.whtankaCd ?? "");
      // 掛率には得意先.単価掛率を設定
      meiMethods.setValue("kakeritsu", fields.tankaKakeritsu);

      //倉庫コード
      meiMethods.setValue("sokoCd", "001");
      // 倉庫名表示
      (async () => {
        await B000190SokoNmSokoshubetsuKbn(meiMethods, navigate, setMsg);

        // セット商品の場合
        if (meiMethods.getValues().setshohinKbn === setshohinKbn.set) {
          await B010010Setshohin(methods, meiMethods, navigate, setMsg);
        }
        // セット商品以外の場合
        else {
          // セット構成品データをクリア
          meiMethods.setValue("koseiData", []);

          // 受注生産品区分を設定
          meiMethods.setValue(
            "juchuSeisanhinKbn",
            getSCode(
              JuchuSeisanhinKbn,
              meiMethods.getValues().shohinshubetsuKbn ===
                shohinshubetsuKbn.madeToOrder
                ? juchuSeisanhinKbn.ari
                : juchuSeisanhinKbn.nashi
            )
          );

          // 単価区分「0:通常単価」の場合
          if (meiMethods.getValues().tankaKbn === tankaKbn.tujo) {
            // 単価取得処理
            await B010010Tanka(methods, meiMethods, navigate, setMsg);
            // 可能数取得
            await B010010Kanosu(meiMethods, navigate, setMsg);
          }
          // 単価区分「1:WH単価」の場合
          else if (meiMethods.getValues().tankaKbn === tankaKbn.wh) {
            // WH 単価取得処理
            await B010010WhTanka(methods, meiMethods, navigate, setMsg);
          }
        }
      })();
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("vol", "");
      meiMethods.setValue("kazeiKbnView", "");
      meiMethods.setValue("kazeiKbn", "");
      meiMethods.setValue("tankaKbn", "");
      meiMethods.setValue("setshohinKbn", "");
      meiMethods.setValue("shohinshubetsuKbn", "");
      meiMethods.setValue("sotosunW", "");
      meiMethods.setValue("sotosunH", "");
      meiMethods.setValue("uchisunW", "");
      meiMethods.setValue("uchisunH", "");
      meiMethods.setValue("shokuchiKbn", "");
      meiMethods.setValue("kakeritsu", "");
      meiMethods.setValue("whtankaCd", "");
      // 受注生産品区分を設定
      meiMethods.setValue(
        "juchuSeisanhinKbn",
        getSCode(JuchuSeisanhinKbn, juchuSeisanhinKbn.nashi)
      );
    });
};

//商品マスタ詳細情報取得処理メソッド(在庫照会ダイアログからの選択)
export const B010010ShohinZaiko = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();
  const meiFields = meiMethods.getValues();

  await B010010GetShohin({ shohinCd: meiFields.shohinCd })
    .then((response) => {
      meiMethods.setValue("vol", response.data.vol ?? "");
      meiMethods.setValue(
        "kazeiKbnView",
        getSCode(HyoziKazeiKbn, response.data.kazeiKbn.toString() ?? "")?.label
      );
      meiMethods.setValue("kazeiKbn", response.data.kazeiKbn ?? "");
      meiMethods.setValue("tankaKbn", response.data.tankaKbn ?? "");
      meiMethods.setValue("setshohinKbn", response.data.setshohinKbn ?? "");
      meiMethods.setValue(
        "shohinshubetsuKbn",
        response.data.shohinshubetsuKbn ?? ""
      );
      meiMethods.setValue("sotosunW", response.data.sotosunW ?? "");
      meiMethods.setValue("sotosunH", response.data.sotosunH ?? "");
      meiMethods.setValue("uchisunW", response.data.uchisunW ?? "");
      meiMethods.setValue("uchisunH", response.data.uchisunH ?? "");
      meiMethods.setValue("shokuchiKbn", response.data.shokuchiKbn ?? "");
      meiMethods.setValue("whtankaCd", response.data.whtankaCd ?? "");
      // 掛率には得意先.単価掛率を設定
      meiMethods.setValue("kakeritsu", fields.tankaKakeritsu);

      // セット商品の場合
      (async () => {
        if (meiMethods.getValues().setshohinKbn === setshohinKbn.set) {
          await B010010Setshohin(methods, meiMethods, navigate, setMsg);
        }
        // セット商品以外の場合
        else {
          // セット構成品データをクリア
          meiMethods.setValue("koseiData", []);

          // 受注生産品区分を設定
          meiMethods.setValue(
            "juchuSeisanhinKbn",
            getSCode(
              JuchuSeisanhinKbn,
              meiMethods.getValues().shohinshubetsuKbn ===
                shohinshubetsuKbn.madeToOrder
                ? juchuSeisanhinKbn.ari
                : juchuSeisanhinKbn.nashi
            )
          );

          // 単価区分「0:通常単価」の場合
          if (meiMethods.getValues().tankaKbn === tankaKbn.tujo) {
            // 単価取得処理
            await B010010Tanka(methods, meiMethods, navigate, setMsg);
          }
          // 単価区分「1:WH単価」の場合
          else if (meiMethods.getValues().tankaKbn === tankaKbn.wh) {
            // WH 単価取得処理
            await B010010WhTanka(methods, meiMethods, navigate, setMsg);
          }
        }
      })();
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("vol", "");
      meiMethods.setValue("kazeiKbnView", "");
      meiMethods.setValue("kazeiKbn", "");
      meiMethods.setValue("tankaKbn", "");
      meiMethods.setValue("setshohinKbn", "");
      meiMethods.setValue("shohinshubetsuKbn", "");
      meiMethods.setValue("sotosunW", "");
      meiMethods.setValue("sotosunH", "");
      meiMethods.setValue("uchisunW", "");
      meiMethods.setValue("uchisunH", "");
      meiMethods.setValue("shokuchiKbn", "");
      meiMethods.setValue("kakeritsu", "");
      meiMethods.setValue("whtankaCd", "");
      // 受注生産品区分を設定
      meiMethods.setValue(
        "juchuSeisanhinKbn",
        getSCode(JuchuSeisanhinKbn, juchuSeisanhinKbn.nashi)
      );
    });
};

export type B010010GetTankaRequest = {
  tankaKbn: string;
  shohinCd: string;
  tokuiCd: string;
  tokuishitenCd: string;
  kijunDate: string;
};

export type B010010GetTankaResponse = {
  jodaitanka: string;
  juchutanka: string;
  aiteCd: string;
};

export const B010010GetTanka = (props: B010010GetTankaRequest) => {
  return RestClient.get<B010010GetTankaResponse>("b010010/get/tanka", {
    params: props,
  });
};

//単価取得処理メソッド
export const B010010Tanka = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();
  const meiFields = meiMethods.getValues();

  await B010010GetTanka({
    tankaKbn: tankaKbnNormal,
    shohinCd: meiFields.shohinCd,
    tokuiCd: fields.tokuiCd,
    tokuishitenCd: fields.tokuishitenCd,
    kijunDate: fields.denpyoYmd,
  })
    .then((response) => {
      const jodaitanka = getJodaitanka(methods, response.data.jodaitanka ?? "");
      meiMethods.setValue("jodaitanka", jodaitanka ?? "");
      meiMethods.setValue("basejodaitanka", jodaitanka ?? "");
      meiMethods.setValue("aiteCd", response.data.aiteCd ?? "");

      // 取得した値を元に他項目を算出
      let kakeritsu: string;
      let juchutanka: string;
      // 下代単価(受注単価)が取得できた場合(取引先別単価マスタ)
      if (response.data.juchutanka !== null) {
        // 下代単価(受注単価)
        juchutanka = getUchizeiJuchutanka(methods, response.data.juchutanka);

        // 掛率(返却された受注単価 * 100 / 返却された上代単価) ※小数点以下切り捨て
        kakeritsu = getKakeritsu(juchutanka, jodaitanka);
      }
      // 下代単価(受注単価)が取得できなかった場合(単価マスタが取得できたOR取得できなかった場合)
      else {
        const fields = methods.getValues();
        // 掛率(得意先マスタ.単価掛率)
        kakeritsu = fields.tankaKakeritsu;
        // 下代単価(受注単価)
        juchutanka = getJuchutanka(methods, jodaitanka, kakeritsu);
      }

      // 掛率
      meiMethods.setValue("kakeritsu", kakeritsu);
      // 下代単価(受注単価)
      meiMethods.setValue("juchutanka", juchutanka);
      meiMethods.setValue("basejuchutanka", juchutanka);
      // 受注金額
      meiMethods.setValue(
        "juchuKin",
        getJuchuKin(
          juchutanka,
          meiMethods.getValues().juchusu,
          methods.getValues().kinmarumeKbn
        )
      );
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("jodaitanka", "");
      meiMethods.setValue("basejodaitanka", "");
      meiMethods.setValue("aiteCd", "");
      meiMethods.setValue("kakeritsu", "");
      meiMethods.setValue("juchutanka", "");
      meiMethods.setValue("basejuchutanka", "");
      meiMethods.setValue("juchuKin", "");
    });
};

export type B010010FindSetshohinRequest = {
  shohinCd: string;
};

export type B010010FindSetshohinResponse = {
  juchukoseigyoNo: string;
  shohinCd: string;
  koseisu: string;
} & Partial<{
  janCd: string;
  shohinNm: string;
  sokoCd: string;
  sokoNm: string;
  sokoshubetsuKbn: string;
  vol: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  kanosu: string;
  jodaitanka: string;
  kazeiKbn: string;
  shohinshubetsuKbn: string;
  tankaKbn: string;
  shokuchiKbn: string;
  whtankaCd: string;
  setshohinKbn: string;
}>;

type KoseiData = Partial<{
  juchugyoNo: string;
  juchukoseigyoNo: string;
  shohinCd: string;
  janCd: string;
  shohinNm: string;
  aiteCd: string;
  sokoCd: string;
  sokoNm: string;
  sokoshubetsuKbn: string;
  vol: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  hitsuyosu: string;
  koseisu: string;
  kanosu: string;
  tenyuryokujodaiKbn: number;
  tenyuryokujuchuKbn: number;
  basejodaitanka: string;
  basejuchutanka: string;
  jodaitanka: string;
  juchutanka: string;
  kakeritsu: string;
  juchuKin: string;
  meisaikoseiBikoCd: string;
  meisaikoseiBiko: string;
  kazeiKbn: string;
  shohinshubetsuKbn: string;
  tankaKbn: string;
  shokuchiKbn: string;
  whtankaCd: string;
  setshohinKbn: string;
  crtDate: string;
  crtshainCd: string;
}>;

//セット商品マスタ取得メソッド
export const B010010FindSetshohin = (props: B010010FindSetshohinRequest) => {
  return RestClient.get<B010010FindSetshohinResponse[]>("b010010/find", {
    params: props,
  });
};

export const B010010Setshohin = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const meiFields = meiMethods.getValues();
  await B010010FindSetshohin({
    shohinCd: meiFields.shohinCd,
  })
    .then((response) => {
      const fields = methods.getValues();
      const koseiDataList: KoseiData[] = [];
      for (let i: number = 0; i < response.data.length; i++) {
        // 必要数
        const hitsuyosu: string = getHitsuyosu(
          response.data[i].koseisu,
          meiFields.juchusu
        );

        // 上代単価
        const jodaitanka = getJodaitanka(
          methods,
          response.data[i].jodaitanka ?? ""
        );

        // 下代単価(受注単価 * 単価掛率 / 100)
        const juchutanka: string = getJuchutanka(
          methods,
          jodaitanka,
          fields.tankaKakeritsu
        );
        // 受注金額
        const juchuKin: string = getJuchuKin(
          juchutanka,
          hitsuyosu,
          methods.getValues().kinmarumeKbn
        );

        const koseiData: KoseiData = {
          juchugyoNo: "",
          juchukoseigyoNo: response.data[i].juchukoseigyoNo ?? "",
          shohinCd: response.data[i].shohinCd ?? "",
          janCd: response.data[i].janCd ?? "",
          shohinNm: response.data[i].shohinNm ?? "",
          aiteCd: "",
          sokoCd: response.data[i].sokoCd ?? "",
          sokoNm: response.data[i].sokoNm ?? "",
          sokoshubetsuKbn: response.data[i].sokoshubetsuKbn ?? "",
          vol: response.data[i].vol ?? "",
          sotosunW: response.data[i].sotosunW ?? "",
          sotosunH: response.data[i].sotosunH ?? "",
          uchisunW: response.data[i].uchisunW ?? "",
          uchisunH: response.data[i].uchisunH ?? "",
          hitsuyosu: hitsuyosu,
          koseisu: response.data[i].koseisu ?? "",
          kanosu: response.data[i].kanosu ?? "",
          tenyuryokujodaiKbn: tenyuryokujodaiKbn.none,
          tenyuryokujuchuKbn: tenyuryokujuchuKbn.none,
          basejodaitanka: jodaitanka,
          basejuchutanka: juchutanka,
          jodaitanka: jodaitanka,
          juchutanka: juchutanka,
          kakeritsu: fields.tankaKakeritsu,
          juchuKin: juchuKin,
          meisaikoseiBikoCd: "",
          meisaikoseiBiko: "",
          kazeiKbn: response.data[i].kazeiKbn ?? "",
          shohinshubetsuKbn: response.data[i].shohinshubetsuKbn ?? "",
          tankaKbn: response.data[i].tankaKbn ?? "",
          shokuchiKbn: response.data[i].shokuchiKbn ?? "",
          whtankaCd: response.data[i].whtankaCd ?? "",
          setshohinKbn: response.data[i].setshohinKbn ?? "",
          crtDate: "",
          crtshainCd: "",
        };

        koseiDataList.push(koseiData);
      }

      meiMethods.setValue("koseiData", koseiDataList);

      // 明細入力部に表示する可能数の設定
      let kanosu: string = "";
      // 構成品に可能数の設定されている行があるかチェック
      const isKanosu: boolean = koseiDataList.some(
        (koseiData: KoseiData) => koseiData.kanosu !== ""
      );
      // 可能数の設定されている行がある場合
      if (isKanosu) {
        kanosu = Math.min(
          ...koseiDataList
            .filter(function (kosei: KoseiData) {
              return kosei.kanosu !== "";
            })
            .map((kosei: KoseiData) => Number(kosei.kanosu))
        ).toString();
      }
      meiMethods.setValue("kanosu", kanosu);

      // 構成品の中に受注生産品が含まれるかどうか
      const isJuchuSeisanhinKbn: boolean = koseiDataList.some(
        (koseiData) =>
          Number(koseiData.shohinshubetsuKbn) === shohinshubetsuKbn.madeToOrder
      );
      // 受注生産品区分を設定
      meiMethods.setValue(
        "juchuSeisanhinKbn",
        getSCode(
          JuchuSeisanhinKbn,
          isJuchuSeisanhinKbn ? juchuSeisanhinKbn.ari : juchuSeisanhinKbn.nashi
        )
      );

      // 受注明細の項目を算出
      // 上代単価(上代 × 構成数)
      const jodaitanka: string = koseiDataList
        .reduce((acc: Big, koseiData: KoseiData): Big => {
          return acc.plus(
            new Big(koseiData.jodaitanka ? koseiData.jodaitanka : "0").times(
              new Big(koseiData.koseisu!)
            )
          );
        }, new Big("0"))
        .toString();

      // 下代単価(下代 × 構成数)
      const juchutanka: string = koseiDataList
        .reduce((acc: Big, koseiData: KoseiData): Big => {
          return acc.plus(
            new Big(koseiData.juchutanka ? koseiData.juchutanka : "0").times(
              new Big(koseiData.koseisu!)
            )
          );
        }, new Big("0"))
        .toString();

      // 掛率(返却された受注単価 * 100 / 返却された上代単価) ※小数点以下切り捨て
      const kakeritsu: string = getKakeritsu(juchutanka, jodaitanka);

      // 受注金額(下代単価 × 受注数) ※小数点以下切り捨て
      const juchuKin: string = getJuchuKin(
        juchutanka,
        meiFields.juchusu,
        methods.getValues().kinmarumeKbn
      );

      meiMethods.setValue("jodaitanka", jodaitanka);
      meiMethods.setValue("basejodaitanka", jodaitanka);
      meiMethods.setValue("juchutanka", juchutanka);
      meiMethods.setValue("basejuchutanka", juchutanka);
      meiMethods.setValue("kakeritsu", kakeritsu);
      meiMethods.setValue("juchuKin", juchuKin);
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("koseiData", []);
      meiMethods.setValue("jodaitanka", "");
      meiMethods.setValue("basejodaitanka", "");
      meiMethods.setValue("juchutanka", "");
      meiMethods.setValue("basejuchutanka", "");
      meiMethods.setValue("kakeritsu", "");
      meiMethods.setValue("juchuKin", "");
    });
};

//消費税取得処理リクエスト
export type B010010GetZeiRitsuRequest = {
  kijunYmd: string;
};

//消費税取得処理レスポンス
export type B010010GetZeiRitsuResponse = {
  zeiRitsu: string;
};

export const B010010GetZeiRitsu = (props: B010010GetZeiRitsuRequest) => {
  return RestClient.get<B010010GetZeiRitsuResponse>("b010010/get/shohizei", {
    params: props,
  });
};

//消費税取得処理メソッド
export const B010010ZeiRitsu = async (methods: UseFormReturn) => {
  const fields = methods.getValues();
  if (!fields.denpyoYmd) {
    return;
  }
  await B010010GetZeiRitsu({ kijunYmd: fields.denpyoYmd }).then((response) => {
    methods.setValue("zeiRitsu", response.data.zeiRitsu ?? "");
  });
};

export type B010010GetTokuiRequest = {
  tokuiCd: string;
  tokuishitenCd: string;
  torihikishuryoYmd: string;
};

export type B010010GetTokuiResponse = {
  tokuiNm: string;
  tokuiShokuchiKbn: number;
  tokuiPostCd: string;
  tokuiAddress1: string;
  tokuiAddress2: string;
  tokuiTelNo: string;
  tokuiFaxNo: string;
  nonyuCd: string;
  nonyushitenCd: string;
  shainCd: string;
  shainNm: string;
  eigyoCd: string;
  bumonCd: string;
  bumonNm: string;
  shimeD: string;
  zeiKbn: string;
  zeimarumeKbn: string;
  jodaihyojiKbn: string;
  kinmarumeKbn: string;
  tankamarumeKbn: string;
  tankahasuichi: string;
  tankaKakeritsu: string;
};
export const B010010GetTokui = (props: B010010GetTokuiRequest) => {
  return RestClient.get<B010010GetTokuiResponse>("b010010/get/tokui", {
    params: props,
  });
};

//得意関連項目取得処理メソッド
export const B010010Tokui = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();
  if (fields.tokuiCd === "" || fields.tokuishitenCd === "") {
    methods.setValue("tokuiNm", "");
    methods.setValue("tokuiShokuchiKbn", undefined);
    methods.setValue("tokuiPostCd", "");
    methods.setValue("tokuiAddress1", "");
    methods.setValue("tokuiAddress2", "");
    methods.setValue("tokuiTelNo", "");
    methods.setValue("tokuiFaxNo", "");
    methods.setValue("nonyuCd", "");
    methods.setValue("nonyushitenCd", "");
    methods.setValue("shainCd", "");
    methods.setValue("shainNm", "");
    methods.setValue("eigyoCd", "");
    methods.setValue("bumonCd", "");
    methods.setValue("bumonNm", "");
    methods.setValue("shimeD", "");
    methods.setValue("zeiKbnView", getSCode(ZeiKbn, ""));
    methods.setValue("zeiKbn", "");
    methods.setValue("zeimarumeKbn", "");
    methods.setValue("jodaihyojiKbn", "");
    methods.setValue("kinmarumeKbn", "");
    methods.setValue("tankamarumeKbn", "");
    methods.setValue("tankahasuichi", "");
    methods.setValue("tankaKakeritsu", "");
    //納入先の関連項目をクリア
    methods.setValue("nonyuShokuchiKbn", "");
    methods.setValue("nonyuNm", "");
    methods.setValue("nonyuPostCd", "");
    methods.setValue("nonyuAddress1", "");
    methods.setValue("nonyuAddress2", "");
    methods.setValue("nonyuTelNo", "");
    methods.setValue("nonyuFaxNo", "");
    methods.setValue("denpyoshubetsuCd", "");
    methods.setValue("denpyoshubetsuNm", "");
    methods.setValue("tenpudenpyoCd", "");
    methods.setValue("tenpudenpyoNm", "");
    methods.setValue("unsogaishaCd", "");
    methods.setValue("unsogaishaNm", "");
    methods.setValue("ritsu", "");
    methods.setValue("denpyoKbn", "");
    methods.setValue("bunrui", "");

    return;
  }
  await B010010GetTokui({
    tokuiCd: fields.tokuiCd,
    tokuishitenCd: fields.tokuishitenCd,
    torihikishuryoYmd: date(),
  })
    .then((response) => {
      methods.setValue("tokuiNm", response.data.tokuiNm ?? "");
      methods.setValue(
        "tokuiShokuchiKbn",
        response.data.tokuiShokuchiKbn ?? undefined
      );

      methods.setValue("tokuiPostCd", response.data.tokuiPostCd ?? "");
      methods.setValue("tokuiAddress1", response.data.tokuiAddress1 ?? "");
      methods.setValue("tokuiAddress2", response.data.tokuiAddress2 ?? "");
      methods.setValue("tokuiTelNo", response.data.tokuiTelNo ?? "");
      methods.setValue("tokuiFaxNo", response.data.tokuiFaxNo ?? "");
      methods.setValue("nonyuCd", response.data.nonyuCd ?? "");
      methods.setValue("nonyushitenCd", response.data.nonyushitenCd ?? "");
      methods.setValue("shainCd", response.data.shainCd ?? "");
      methods.setValue("shainNm", response.data.shainNm ?? "");
      methods.setValue("eigyoCd", response.data.eigyoCd ?? "");
      methods.setValue("bumonCd", response.data.bumonCd ?? "");
      methods.setValue("bumonNm", response.data.bumonNm ?? "");
      methods.setValue("shimeD", response.data.shimeD ?? "");
      methods.setValue(
        "zeiKbnView",
        getSCode(ZeiKbn, response.data.zeiKbn ?? "")
      );
      methods.setValue("zeiKbn", response.data.zeiKbn ?? "");
      methods.setValue("zeimarumeKbn", response.data.zeimarumeKbn ?? "");
      methods.setValue("jodaihyojiKbn", response.data.jodaihyojiKbn ?? "");
      methods.setValue("kinmarumeKbn", response.data.kinmarumeKbn ?? "");
      methods.setValue("tankamarumeKbn", response.data.tankamarumeKbn ?? "");
      methods.setValue("tankahasuichi", response.data.tankahasuichi ?? "");
      methods.setValue("tankaKakeritsu", response.data.tankaKakeritsu ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tokuiNm", "");
      methods.setValue("tokuiShokuchiKbn", undefined);
      methods.setValue("tokuiPostCd", "");
      methods.setValue("tokuiAddress1", "");
      methods.setValue("tokuiAddress2", "");
      methods.setValue("tokuiTelNo", "");
      methods.setValue("tokuiFaxNo", "");
      methods.setValue("nonyuCd", "");
      methods.setValue("nonyushitenCd", "");
      methods.setValue("shainCd", "");
      methods.setValue("bumonCd", "");
      methods.setValue("shimeD", "");
      methods.setValue("zeiKbnView", getSCode(ZeiKbn, ""));
      methods.setValue("zeiKbn", "");
      methods.setValue("zeimarumeKbn", "");
      methods.setValue("kinmarumeKbn", "");
      methods.setValue("tankamarumeKbn", "");
      methods.setValue("tankahasuichi", "");
      methods.setValue("tankaKakeritsu", "");
      //納入先の関連項目をクリア
      methods.setValue("nonyuShokuchiKbn", "");
      methods.setValue("nonyuNm", "");
      methods.setValue("nonyuPostCd", "");
      methods.setValue("nonyuAddress1", "");
      methods.setValue("nonyuAddress2", "");
      methods.setValue("nonyuTelNo", "");
      methods.setValue("nonyuFaxNo", "");
      methods.setValue("denpyoshubetsuCd", "");
      methods.setValue("denpyoshubetsuNm", "");
      methods.setValue("tenpudenpyoCd", "");
      methods.setValue("tenpudenpyoNm", "");
      methods.setValue("unsogaishaCd", "");
      methods.setValue("unsogaishaNm", "");
      methods.setValue("ritsu", "");
      methods.setValue("denpyoKbn", "");
      methods.setValue("bunrui", "");
      // 受注担当者関連の項目クリア
      methods.setValue("shainNm", "");
      methods.setValue("bumonCd", "");
      methods.setValue("bumonNm", "");
      methods.setValue("eigyoCd", "");
    });
  // 納入先関連項目設定
  await B010010Nonyu(methods, navigate, setMsg);
};

export type B010010GetNonyuRequest = {
  nonyuCd: string;
  nonyushitenCd: string;
  torihikishuryoYmd: string;
};

export type B010010GetNonyuResponse = {
  nonyuNm: string;
  nonyuShokuchiKbn: string;
  nonyuPostCd: string;
  nonyuAddress1: string;
  nonyuAddress2: string;
  nonyuTelNo: string;
  nonyuFaxNo: string;
  denpyoshubetsuCd: string;
  denpyoshubetsuNm: string;
  tenpudenpyoCd: string;
  tenpudenpyoNm: string;
  ritsu: string;
  denpyoKbn: string;
  unsogaishaCd: string;
  unsogaishaNm: string;
  bunrui: string;
};
export const B010010GetNonyu = (props: B010010GetNonyuRequest) => {
  return RestClient.get<B010010GetNonyuResponse>("b010010/get/nonyu", {
    params: props,
  });
};

//納入関連項目取得処理メソッド
export const B010010Nonyu = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();
  if (fields.nonyuCd === "" || fields.nonyushitenCd === "") {
    methods.setValue("nonyuNm", "");
    methods.setValue("nonyuShokuchiKbn", "");
    methods.setValue("nonyuPostCd", "");
    methods.setValue("nonyuAddress1", "");
    methods.setValue("nonyuAddress2", "");
    methods.setValue("nonyuTelNo", "");
    methods.setValue("nonyuFaxNo", "");
    methods.setValue("denpyoshubetsuCd", "");
    methods.setValue("denpyoshubetsuNm", "");
    methods.setValue("tenpudenpyoCd", "");
    methods.setValue("tenpudenpyoNm", "");
    methods.setValue("unsogaishaCd", "");
    methods.setValue("unsogaishaNm", "");
    methods.setValue("ritsu", "");
    methods.setValue("denpyoKbn", "");
    methods.setValue("bunrui", "");
    return;
  }
  await B010010GetNonyu({
    nonyuCd: fields.nonyuCd,
    nonyushitenCd: fields.nonyushitenCd,
    torihikishuryoYmd: date(),
  })
    .then((response) => {
      methods.setValue("nonyuNm", response.data.nonyuNm ?? "");
      methods.setValue(
        "nonyuShokuchiKbn",
        response.data.nonyuShokuchiKbn ?? ""
      );
      methods.setValue("nonyuPostCd", response.data.nonyuPostCd ?? "");
      methods.setValue("nonyuAddress1", response.data.nonyuAddress1 ?? "");
      methods.setValue("nonyuAddress2", response.data.nonyuAddress2 ?? "");
      methods.setValue("nonyuTelNo", response.data.nonyuTelNo ?? "");
      methods.setValue("nonyuFaxNo", response.data.nonyuFaxNo ?? "");
      methods.setValue(
        "denpyoshubetsuCd",
        response.data.denpyoshubetsuCd ?? ""
      );
      methods.setValue(
        "denpyoshubetsuNm",
        response.data.denpyoshubetsuNm ?? ""
      );
      methods.setValue("tenpudenpyoCd", response.data.tenpudenpyoCd ?? "");
      methods.setValue("tenpudenpyoNm", response.data.tenpudenpyoNm ?? "");
      methods.setValue("ritsu", response.data.ritsu ?? "");
      methods.setValue("denpyoKbn", response.data.denpyoKbn ?? "");
      methods.setValue("unsogaishaCd", response.data.unsogaishaCd ?? "");
      methods.setValue("unsogaishaNm", response.data.unsogaishaNm ?? "");
      methods.setValue("bunrui", response.data.bunrui ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("nonyuNm", "");
      methods.setValue("nonyuShokuchiKbn", "");
      methods.setValue("nonyuPostCd", "");
      methods.setValue("nonyuAddress1", "");
      methods.setValue("nonyuAddress2", "");
      methods.setValue("nonyuTelNo", "");
      methods.setValue("nonyuFaxNo", "");
      methods.setValue("denpyoshubetsuCd", "");
      methods.setValue("denpyoshubetsuNm", "");
      methods.setValue("tenpudenpyoCd", "");
      methods.setValue("tenpudenpyoNm", "");
      methods.setValue("unsogaishaCd", "");
      methods.setValue("unsogaishaNm", "");
      methods.setValue("ritsu", "");
      methods.setValue("denpyoKbn", "");
      methods.setValue("bunrui", "");
    });
};

export type B010010GetKanosuRequest = {
  shohinCd: string;
  sokoCd: string;
} & Partial<{
  sotosunW: string;
  sotosunH: string;
  zairyohikiatesuBefore: string;
}>;

export type B010010GetKanosuResponse = {
  kanosu: string;
  zairyohikiateKanoNagasa: string;
  zairyohikiateNagasa: string;
};

export const B010010GetKanosu = (props: B010010GetKanosuRequest) => {
  return RestClient.get<B010010GetKanosuResponse>("b010010/get/hikiate", {
    params: props,
  });
};

//引当可能数取得処理メソッド
export const B010010Kanosu = async (
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = meiMethods.getValues();
  if (data.shohinCd === "" || data.sokoCd === "") {
    meiMethods.setValue("kanosu", "");
    return;
  }

  // 前回分の材料引当数
  let zairyohikiatesuBefore: string = "";
  if (data.shohinCd === data.shohinCdBefore) {
    zairyohikiatesuBefore = data.zairyohikiatesuBefore;
  }

  await B010010GetKanosu({
    shohinCd: data.shohinCd,
    sokoCd: data.sokoCd,
    sotosunW: data.sotosunW,
    sotosunH: data.sotosunH,
    zairyohikiatesuBefore: zairyohikiatesuBefore,
  })
    .then((response) => {
      meiMethods.setValue("kanosu", response.data.kanosu ?? "");
      meiMethods.setValue(
        "zairyohikiateKanoNagasa",
        response.data.zairyohikiateKanoNagasa ?? ""
      );
      meiMethods.setValue(
        "zairyohikiateNagasa",
        response.data.zairyohikiateNagasa ?? ""
      );
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("kanosu", "0");
    });
};

export type B010010GetWhTankaRequest = {
  whtankaKbn: string;
  whtankaCd: string;
  height: string;
  width: string;
};

export type B010010GetWhTankaResponse = {
  tanka: string;
};
export const B010010GetWhTanka = (props: B010010GetWhTankaRequest) => {
  return RestClient.get<B010010GetWhTankaResponse>("b010010/get/whtanka", {
    params: props,
  });
};

//WH単価取得処理メソッド
export const B010010WhTanka = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = meiMethods.getValues();

  // 受注生産品ではない場合
  if (data.shohinshubetsuKbn !== shohinshubetsuKbn.madeToOrder) {
    // 何もしない
    return;
  }

  // 単価区分「0:通常」の場合
  if (data.tankaKbn === tankaKbn.tujo) {
    // 何もしない
    return;
  }

  // 入力済みではない場合
  if (data.whtankaCd === "" || data.sotosunH === "" || data.sotosunW === "") {
    // 可能数をクリア
    meiMethods.setValue("kanosu", "");
    return;
  }

  await B010010GetWhTanka({
    whtankaKbn: whtankaKbnWh,
    whtankaCd: data.whtankaCd,
    height: data.sotosunH,
    width: data.sotosunW,
  })
    .then((response) => {
      // 上代単価取得
      const jodaitanka = getJodaitanka(methods, response.data.tanka);
      // 上代単価
      meiMethods.setValue("jodaitanka", jodaitanka ?? "");
      meiMethods.setValue("basejodaitanka", jodaitanka ?? "");

      // 受注単価取得
      const juchutanka: string = getJuchutanka(
        methods,
        jodaitanka,
        meiMethods.getValues().kakeritsu
      );

      // 下代単価(受注単価)
      meiMethods.setValue("juchutanka", juchutanka);
      meiMethods.setValue("basejuchutanka", juchutanka);
      // 受注金額
      meiMethods.setValue(
        "juchuKin",
        getJuchuKin(
          juchutanka,
          meiMethods.getValues().juchusu,
          methods.getValues().kinmarumeKbn
        )
      );

      // 可能数取得
      B010010Kanosu(meiMethods, navigate, setMsg);
    })
    .catch((reason) => {
      // WH単価取得の返却値が存在しない場合、ここに入る
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("kanosu", "0");
      meiMethods.setValue("jodaitanka", "");
      meiMethods.setValue("basejodaitanka", "");
      meiMethods.setValue("juchutanka", "");
      meiMethods.setValue("basejuchutanka", "");
      meiMethods.setValue("juchuKin", "");
    });
};

// 単価リスト検索リクエスト
export type B010010GetTankaListRequest = {
  tankaKbn: string;
  shohinCdList: string[];
  tokuiCd: string;
  tokuishitenCd: string;
  kijunDate: string;
};

// 単価リスト検索レスポンス
export type B010010GetTankaListResponse = {
  shohinCd: string;
  jodaitanka: string;
  juchutanka: string;
  aiteCd: string;
};

// 単価リスト検索
export const B010010GetTankaList = (props: B010010GetTankaListRequest) => {
  return RestClient.get<B010010GetTankaListResponse[]>("b010010/find/tanka", {
    params: props,
  });
};

//単価リスト検索処理メソッド
export const B010010TankaList = async (
  methods: UseFormReturn,
  shohinCdList: string[],
  rows: any,
  setRows: Function,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();

  await B010010GetTankaList({
    tankaKbn: tankaKbnNormal,
    shohinCdList: shohinCdList,
    tokuiCd: fields.tokuiCd,
    tokuishitenCd: fields.tokuishitenCd,
    kijunDate: fields.denpyoYmd,
  })
    .then((response) => {
      for (const data of response.data) {
        for (const row of rows) {
          // 商品コードが一致しない場合、何もしない
          if (data.shohinCd !== row.shohinCd) continue;
          // 上代単価が編集されている場合、何もしない
          if (row.tenyuryokujodaiKbn === tenyuryokujodaiKbn.exists) continue;
          // 下代単価が編集されている場合、何もしない
          if (row.tenyuryokujuchuKbn === tenyuryokujuchuKbn.exists) continue;

          // 上代初期値計算処理をよびだす
          const jodaitanka = getJodaitanka(methods, data.jodaitanka);
          // 取得した値を元に他項目を算出
          let kakeritsu: string;
          let juchutanka: string;

          // 下代単価(受注単価)が取得できた場合
          if (data.juchutanka !== null) {
            // 下代単価(受注単価)
            juchutanka = getUchizeiJuchutanka(methods, data.juchutanka);

            // 掛率(返却された受注単価 * 100 / 返却された上代単価) ※小数点以下切り捨て
            kakeritsu = getKakeritsu(juchutanka, jodaitanka);
          }
          // 下代単価(受注単価)が取得できなかった場合(単価マスタが取得できたOR取得できなかった場合)
          else {
            const fields = methods.getValues();
            // 掛率(得意先マスタ.単価掛率)
            kakeritsu = fields.tankaKakeritsu;
            // 下代単価(受注単価)
            juchutanka = getJuchutanka(methods, jodaitanka, kakeritsu);
          }

          // 上代単価
          row.jodaitanka = jodaitanka;
          row.basejodaitanka = jodaitanka;
          // 下代単価(受注単価)
          row.juchutanka = juchutanka;
          row.basejuchutanka = juchutanka;
          // 掛率
          row.kakeritsu = kakeritsu;
          // 受注金額
          row.juchuKin = getJuchuKin(
            juchutanka,
            row.juchusu,
            methods.getValues().kinmarumeKbn
          );
        }
      }
      // 明細に反映
      setRows([...rows]);
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
    });
};
